import {Flex, Image, Text} from '@mantine/core';
import classes from './TableFileName.module.css';


interface TableFileNameProps {
    text: string
}

function TableFileName({text}: TableFileNameProps) {

    let asset;
    if (!text.includes(".")) {
        asset = "assets/icon-folder.png"
    } else
        if (text.endsWith("csv")) {
            asset = "assets/icon-csv.png"
        }

    return (
        <Flex align={'center'}>

            <Image src={asset} className={classes.icon} />
            <Text size="sm" style={{paddingLeft: '8px'}}>
                {text}
            </Text>
        </Flex>

    )
}

export default TableFileName;